export const baseUrls = {
  //  ================================ DEVELOPMENT ============================
//   base: 'https://apimlwdev.clientwork.xyz/api/',
//   bill: 'https://apimlwdev.clientwork.xyz/',
//   digi: 'https://apimlwdev.clientwork.xyz/digitalservice/',
//   user: 'https://apimlwdev.clientwork.xyz/userservice/',
//   images: 'https://apimlwdev.clientwork.xyz/',
//   global: 'https://apimlwdev.clientwork.xyz/',
//  // Anand Hindustanii
//   hostedUrl: 'https://mlwdev.clientwork.xyz/',
//   // hostedUrl: 'http://localhost:4200/',
//    //Anand Hindustanii
//   shop: 'https://apimlwdev.clientwork.xyz/shopservice/',
//   ssoUrl: 'https://ssomlwdev.clientwork.xyz/',

  //  =================================== LIVE PRODUCTION URLS ================
  base: 'https://api.mylifewell.com/api/',
  bill: 'https://api.mylifewell.com/',
  images: 'https://cdn.mylifewell.com/',
  user: 'https://api.mylifewell.com/userservice/',
  global: 'https://www.mylifewell.com/',
  digi: 'https://api.mylifewell.com/digitalservice/',
  hostedUrl: 'https://www.mylifewell.com/',
  shop: 'https://api.mylifewell.com/shopservice/',
  ssoUrl: 'https://ssomlwdev.clientwork.xyz/',


  // ======================================= New SERVER urls STAGING ==============
  // base: 'https://apimylifewell.clientwork.xyz/api/',
  // digi: 'https://apimylifewell.clientwork.xyz/digitalservice/',
  // user: 'https://apimylifewell.clientwork.xyz/userservice/',
  // bill: 'https://apimylifewell.clientwork.xyz/',
  // images: 'https://mylifewell.clientwork.xyz/',
  // global: 'https://apimylifewell.clientwork.xyz/',

  //=====================================Local server ===========================
  // base: 'http://localhost:3006/api/', //travel
  // bill: 'http://localhost:3004/',  //billing
  // digi: 'http://localhost:3000/digitalservice/', //digital
  // user: 'http://localhost:3003/userservice/',
  // images: 'http://localhost:3002/',   //commonservice
  // global: 'http://localhost:4200/',
  // hostedUrl:'http://localhost:4200/',
  // shop:'http://localhost:3008/shopservice/',
  // ssoUrl:"http://localhost:4000/web/login"
}
